import { GetCpntPjt } from "../../services/component-projects/get-component-projects-deploy-candidate/GetComponentProjectsDeployCandidateResponse";
import { Option } from "../../util/option";
import { DisplayColumn, ErrorMessage } from "../../util/spreadsheet-data-utils";

export type ComponentProjectListRequestPageState = {
  cpntPjtList: CpntPjtInfo[];
  generalCode: GeneralCode;
  isEdited: boolean;
  displayColumn: DisplayColumn[];
  dipByRegion: string;
  componentId: string;
  fieldPath: {
    dipByRgn: string;
    rootCpntId: string;
    cpntId: string;
    pjtSts: string;
  };
};

export type SpreadsheetState = {
  envType: string;
  cpntPjtList: CpntPjtInfo[];
  generalCode: GeneralCode;
};

export type CpntPjtInfo = {
  idx: number;
  isEdited: boolean;
  isChecked: boolean;
  message: string;
  cpntPjt: GetCpntPjt;
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};

export type GeneralCode = {
  inDefCommonFlagType: Option[];
  tcktStsTypeCpntPrjPrgrs: Option[];
  edhProtocolList: Option[];
};
export type PageNewState =
  | ComponentProjectListRequestPageState
  | ((
      prevState: ComponentProjectListRequestPageState,
    ) => ComponentProjectListRequestPageState);
